import { useGame } from "../services/gameContext";

// Two-button game selector — sits at the top of Directory + Calendar
// and controls which sellers/buyers/season assets render below.
// Rectangular tabs (not pill-shaped) with a bottom accent bar under
// the active tab; left-aligned by the parent so the picker feels
// like a real toolbar control instead of a floating widget.

// Pulled from PlayAware app's app_dominant_color_map.dart so the
// picker matches the frame colours the user sees inside the app.
const ACCENTS = {
  BGMI: "#F88200",
  PUBG: "#258BC8",
};

export default function GamePicker({ style }) {
  const { game, setGame, games } = useGame();
  return (
    <div
      role="tablist"
      style={{
        display: "inline-flex",
        gap: 0,
        borderRadius: 6,
        overflow: "hidden",
        border: "1px solid rgba(255,255,255,0.10)",
        background: "rgba(255,255,255,0.02)",
        ...style,
      }}
    >
      {games.map((g, idx) => {
        const active = g === game;
        const accent = ACCENTS[g];
        return (
          <button
            key={g}
            role="tab"
            aria-selected={active}
            onClick={() => setGame(g)}
            style={{
              position: "relative",
              padding: "10px 26px",
              minWidth: 96,
              borderRadius: 0,
              borderLeft:
                idx > 0 ? "1px solid rgba(255,255,255,0.10)" : "none",
              borderTop: "none",
              borderRight: "none",
              borderBottom: active
                ? `3px solid ${accent}`
                : "3px solid transparent",
              background: active ? `${accent}22` : "transparent",
              color: active ? "#fff" : "#9ca0a8",
              fontWeight: 900,
              letterSpacing: 1.8,
              fontSize: 12.5,
              cursor: "pointer",
              transition:
                "background 0.15s, color 0.15s, border-color 0.15s",
              textTransform: "uppercase",
              lineHeight: 1,
              boxSizing: "border-box",
            }}
          >
            {g}
          </button>
        );
      })}
    </div>
  );
}
